import { createContext, useContext, useState } from 'react';
import Loading from '../components/UI/Loading';

export const LoadingContext = createContext({});

export const LoadingProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);

    const show = () => {
        setLoading(true);
        document.body.style.overflowY = "hidden";
    }

    const hide = () => {
        setLoading(false);
        document.body.style.overflowY = "auto";
    }

    return (
        <LoadingContext.Provider value={{ hide, show, loading }}>
            {children}
            { loading ? <Loading /> : '' }
        </LoadingContext.Provider>
    )
}

export const useLoading = () => useContext(LoadingContext)
